import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { InjectShipmentDependencies } from './components/InjectShipmentDependencies';

export function ShipmentRoute(props: RouteComponentProps) {
  return <Route path={props.match.path} component={InjectShipmentDependencies}/>;
}

